import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {ConnectionStatus} from '../../../interfaces/Backend';
import {usePollBackendQuery} from '../api/backendApi';
import {setBackend, setBlastMode} from '../backendSlice';

export const useBackendPolling = () => {
  const {data, error} = usePollBackendQuery(undefined, {
    pollingInterval: 10_000,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      dispatch(setBackend(data));
      dispatch(
        setBlastMode({
          timeout: data.blastModeCounter,
          status: data.blastModeStatus,
        })
      );
    }

    if (error) {
      dispatch(
        setBackend({
          version: 'unknown',
          connected: false,
          delay: 0,
          connection_status: ConnectionStatus.DISCONNECTED,
          branch: '',
          build: 0,
          blastModeStatus: false,
          blastModeCounter: null,
          license: false,
        })
      );
    }
  }, [data, error, dispatch]);
};
